import { Predicate } from '@app/types';
import { toJsonString } from '@util/object';
import * as R from 'ramda';

interface ThrowIf {
  <T>(errorMessage: string, predicate: Predicate<T>, value: T): void;
  <T>(errorMessage: string, predicate: Predicate<T>): (value: T) => void;
  (errorMessage: string): <T>(predicate: Predicate<T>) => (value: T) => void;
}

export const throwIf: ThrowIf = R.curry(<T>(errorMessage: string, predicate: Predicate<T>, value: T): void => {
  if (predicate(value)) {
    throw new Error(errorMessage);
  }
});

export const throwError = (errorMessage: string) => (props: any) => {
  throw new Error(`${errorMessage}: ${toJsonString(props)}`);
};
